var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroup697(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 373.779,
    height: 294.971,
    viewBox: "0 0 373.779 294.971",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_697",
    "data-name": "Group 697",
    transform: "translate(0 -153.029)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1775",
    "data-name": "Path 1775",
    d: "M-3715,406l169.9-34.22s58.765-63.562,110.335-69.559,93.545,26.384,93.545,26.384V182.292l-146.313,16.79-95.943,81.552L-3715,302.221Z",
    transform: "translate(3715)",
    fill: "#f9c8c5",
    opacity: 0.53
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_549",
    "data-name": "Group 549",
    transform: "translate(-1971.452 -889.792)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_638",
    "data-name": "Group 638",
    transform: "translate(2017.452 1042.821)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_617",
    "data-name": "Group 617",
    transform: "translate(38.083 39.454)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1489",
    "data-name": "Path 1489",
    d: "M1822.269,815.045l41.7-.278,35.87-.371.155,5.442c-12.467,4.815-22.252,6.271-34.669,7.194-12.578,4.177-29.233,6.938-42.116,7.845C1811.886,835.415,1810.942,815.584,1822.269,815.045Z",
    transform: "translate(-1805.906 -800.685)",
    fill: "#f7a594"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1490",
    "data-name": "Path 1490",
    d: "M1811.016,808.531c-5.007-.1-19.822-1.665-29.055-.577-8.355,3.431-6.283,18-2.455,20.295-.011.412,16.209,4.939,32.621.123C1814.6,825.48,1813.76,811.416,1811.016,808.531Z",
    transform: "translate(-1776.164 -795.353)",
    fill: "#614385"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1491",
    "data-name": "Path 1491",
    d: "M1920.358,828.891c-2.6.926-5.045,1.513-6.872.765-1.083.052-2.289-21.777-1.205-21.829l6.826-.325C1921.274,807.4,1922.525,828.787,1920.358,828.891Z",
    transform: "translate(-1882.183 -795.298)",
    fill: "#9a82b8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_616",
    "data-name": "Group 616",
    transform: "translate(88.831)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1492",
    "data-name": "Path 1492",
    d: "M2183.344,765.835c1.214-5.618,3.153-13.607,5.51-13.719.508-.024.583.3.557,1.8-1.171,9.986,1.524,12.694.222,15.516-1.433,2.735-5.379,2.681-5.379,2.681C2182.042,771.122,2181.861,767.424,2183.344,765.835Z",
    transform: "translate(-2182.383 -752.023)",
    fill: "#f7a594"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1493",
    "data-name": "Path 1493",
    d: "M2199.107,783.407l2.458-7.252a1.71,1.71,0,0,1,1.266,2.2c-.337,1.917-.746,3.981-.746,3.981s1.921,4.151.392,5.87S2198.311,788.243,2199.107,783.407Z",
    transform: "translate(-2195.335 -770.807)",
    fill: "#f7a594"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1494",
    "data-name": "Path 1494",
    d: "M2203.005,787.5l-.187-.06a8.059,8.059,0,0,0-.629-5.458l-.016-.031.007-.034c0-.021.412-2.085.746-3.979a1.733,1.733,0,0,0-.474-1.727,1.689,1.689,0,0,0-.631-.338l-2.428,7.168-.186-.063,2.484-7.332.083.015a1.843,1.843,0,0,1,.807.4,1.91,1.91,0,0,1,.539,1.909c-.311,1.764-.687,3.676-.74,3.95A8.221,8.221,0,0,1,2203.005,787.5Z",
    transform: "translate(-2195.527 -770.409)",
    fill: "#d97b69"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1495",
    "data-name": "Path 1495",
    d: "M2194.025,760.841l-.19-.048c.087-.345,2.156-8.465,3.934-9.1l.066.185C2196.154,752.478,2194.046,760.757,2194.025,760.841Z",
    transform: "translate(-2191.331 -751.697)",
    fill: "#d97b69"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_619",
    "data-name": "Group 619",
    transform: "translate(0 102.466)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_618",
    "data-name": "Group 618",
    transform: "translate(0 143.873)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1496",
    "data-name": "Path 1496",
    d: "M1608.565,1720.226h19.187a2.134,2.134,0,0,0,.823-.771c.306-14.27,1.4-21.141,1.4-21.141l-13.389-.544-2.517,10.616C1609.739,1711.446,1604.716,1718.011,1608.565,1720.226Z",
    transform: "translate(-1606.06 -1697.77)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1497",
    "data-name": "Path 1497",
    d: "M1625.172,1790.333h-22.748c-.577,0-.535-3.164.042-3.164l22.618.127C1625.678,1787.3,1625.766,1790.333,1625.172,1790.333Z",
    transform: "translate(-1602.012 -1767.62)",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1498",
    "data-name": "Path 1498",
    d: "M1646.128,1056.441c-1.358,10.564-7.164,36.659-6.538,65.353-6.287,36.571-6.979,44.626-7.742,67.182l19.179.717c3.069-15.752,9.369-40.615,12.223-64.873,6.2-19.115,10.26-46.357,12.255-67.988C1677.517,1038.192,1651.163,1030.655,1646.128,1056.441Z",
    transform: "translate(-1625.324 -1039.846)",
    fill: "#614385"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1499",
    "data-name": "Path 1499",
    d: "M1673.322,1274.939l-.392-.005c.035-2.6,7.828-90.551,15.744-126.207l.383.085C1681.146,1184.446,1673.357,1272.34,1673.322,1274.939Z",
    transform: "translate(-1657.422 -1124.917)",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_620",
    "data-name": "Group 620",
    transform: "translate(39.831 100.753)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1500",
    "data-name": "Path 1500",
    d: "M1784.4,1051.611a429.952,429.952,0,0,0,10.667,67.29c-1.559,24.824,2.844,48.66,5.975,64.964l18.245-.163c1.057-15.963-1.2-102.372-5.921-131.677C1811.12,1026.114,1781.15,1024.727,1784.4,1051.611Z",
    transform: "translate(-1784.158 -1032.014)",
    fill: "#614385"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1501",
    "data-name": "Path 1501",
    d: "M1873.622,1725.838c-.816,5.88-1.385,10.467-.669,15.789l29.838.58s2.813-2.874-1.1-7.184-10.842-1.817-15.765-9.348Z",
    transform: "translate(-1853.281 -1573.987)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1502",
    "data-name": "Path 1502",
    d: "M1902.068,1790.333H1870.4c-.577,0-.577-3.164,0-3.164l31.544.127C1902.534,1787.3,1902.662,1790.333,1902.068,1790.333Z",
    transform: "translate(-1851.2 -1622.034)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_462",
    "data-name": "Rectangle 462",
    width: 0.392,
    height: 125.807,
    transform: "translate(24.446 25.849) rotate(-2.847)",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1503",
    "data-name": "Path 1503",
    d: "M1710.23,876.783,1662.8,880.4c.43-29.695-12.978-50.2-10.187-57.846,3.835-10.506,31.789-10.58,42.435-6.484,4.228,1.627,11.1,11.034,11.913,22.87a79.436,79.436,0,0,1-.254,13.687C1706.175,857.028,1710.23,876.783,1710.23,876.783Z",
    transform: "translate(-1641.252 -760.568)",
    fill: "#614385"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1504",
    "data-name": "Path 1504",
    d: "M1740.161,771.8c-2.2-1.751-11-4.453-13.338-6.368l.528-15.266,8.647-.842a25.692,25.692,0,0,1,7.173,1.661l1.946,10.052.429,2.18C1746.525,765.366,1744.585,767.953,1740.161,771.8Z",
    transform: "translate(-1699.53 -710.392)",
    fill: "#f7a594"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1505",
    "data-name": "Path 1505",
    d: "M1742.544,764.4a19.317,19.317,0,0,0,14.856,7.415l-1.684-8.7Z",
    transform: "translate(-1711.813 -721.167)",
    fill: "#e6836f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_623",
    "data-name": "Group 623",
    transform: "translate(14.483)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_621",
    "data-name": "Group 621",
    transform: "translate(5.869 10.757)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1506",
    "data-name": "Path 1506",
    d: "M1730.964,637.231c.678,3.008,2.075,9.61,1.847,12.651-.348,4.63-4.672,9.765-8.443,10.439-4.365.445-10.25-.855-13.445-3.6a44.042,44.042,0,0,1-6.8-11.355c-3.3-9.026,3.074-16.942,11.166-18.77S1728.85,627.854,1730.964,637.231Z",
    transform: "translate(-1701.446 -624.863)",
    fill: "#f7a594"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1507",
    "data-name": "Path 1507",
    d: "M1700.463,646.93c-1.687-2.97.555-4.173,3.013-1.867-.42-2.241-2.975-8.807-.712-10.984,2.556-2.526,13.8-1.427,19.847-7.728,0,0-4.5-9.875-19.287-4.043C1686.627,631.161,1700.463,646.93,1700.463,646.93Z",
    transform: "translate(-1695.081 -620.465)",
    fill: "#4d261c"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_135",
    "data-name": "Ellipse 135",
    cx: 2.832,
    cy: 3.644,
    rx: 2.832,
    ry: 3.644,
    transform: "translate(0.774 24.44) rotate(-39.724)",
    fill: "#f7a594"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1508",
    "data-name": "Path 1508",
    d: "M1737.015,649.157c-1.879-.575-24.252,8.316-23.664,9.978,0,0,16.2.075,27.337-5C1746.767,651.37,1737.015,649.157,1737.015,649.157Z",
    transform: "translate(-1703.478 -632.105)",
    fill: "#462c65"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1509",
    "data-name": "Path 1509",
    d: "M1688.881,646.735l27.178-11.455-.929-3.85-28.791,11.879A8.473,8.473,0,0,0,1688.881,646.735Z",
    transform: "translate(-1682.381 -618.276)",
    fill: "#614385"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1510",
    "data-name": "Path 1510",
    d: "M1671.416,597.166c-2.973,1.133-4.566-.683-1.563-4.138,4.632-5.33,7.8-18.963,14.675-21.435,4.741-1.7,8.329,3.848,14.622,7.3,2.855,1.564,4.453,3.2,3.383,5.121C1699.281,586.446,1674.529,595.98,1671.416,597.166Z",
    transform: "translate(-1668.244 -571.276)",
    fill: "#462c65"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_622",
    "data-name": "Group 622",
    transform: "translate(15.731 4.774)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1511",
    "data-name": "Path 1511",
    d: "M1746.494,593.788l-.057-.153a7.241,7.241,0,0,1-2.009,0,5.807,5.807,0,0,1-1.762-.525h0l0,.008a5.189,5.189,0,0,1-.41.786,6.615,6.615,0,0,1-.786,1c-.151.16-.308.316-.477.464a7.09,7.09,0,0,1-.806.613l.341.908.17.453.1.272.384,1.023a4.422,4.422,0,0,0,.794,1.342,4.539,4.539,0,0,0,.333.347,5.174,5.174,0,0,0,1.1.782,6.5,6.5,0,0,0,1.108.461,7.2,7.2,0,0,0,1.144.259c.136.019.239.029.3.033a7.348,7.348,0,0,0,.706-.885,7.077,7.077,0,0,0,.376-.62c.062-.114.121-.234.179-.358a4.711,4.711,0,0,0,.211-3.7Z",
    transform: "translate(-1740.183 -593.108)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1512",
    "data-name": "Path 1512",
    d: "M1753.328,604.644a2.172,2.172,0,1,1-2.788-1.274A2.165,2.165,0,0,1,1753.328,604.644Z",
    transform: "translate(-1747.165 -601.019)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_624",
    "data-name": "Group 624",
    transform: "translate(25.375 50.41)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1513",
    "data-name": "Path 1513",
    d: "M1782.7,832.139l1.429,3,.219-3.182,1.927,5.116a5.715,5.715,0,0,0-2.114-1.594,5.9,5.9,0,0,0-2.642,2.76Z",
    transform: "translate(-1767.638 -825.358)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1514",
    "data-name": "Path 1514",
    d: "M1720.073,806.194c2.134,2.753,9.078,4.638,13.036,5.819l-1.18,6.095c-4.756-1.606-10.9-3.429-13.661-9.119C1717.646,807.441,1718.389,806.581,1720.073,806.194Z",
    transform: "translate(-1718.05 -805.233)",
    fill: "#9a82b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1515",
    "data-name": "Path 1515",
    d: "M1797.987,801.8c-.212,1-.375,4.932-3.535,6.594l1.927,5.116c4.356-2.493,4.585-4.8,3.915-8.425C1800.02,803.644,1799.539,802.1,1797.987,801.8Z",
    transform: "translate(-1777.745 -801.799)",
    fill: "#9a82b8"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1516",
    "data-name": "Path 1516",
    d: "M1800.392,905.765a.2.2,0,0,1-.195-.175c-.487-4.525-.883-9.922-1.3-15.636-1.14-15.566-2.432-33.21-6.179-42.525a.2.2,0,0,1,.364-.146c3.77,9.372,5.064,27.048,6.206,42.643.418,5.71.813,11.1,1.3,15.623a.2.2,0,0,1-.174.216Z",
    transform: "translate(-1751.003 -786.83)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1517",
    "data-name": "Path 1517",
    d: "M1691.816,1096.861c9.271,2.484,45.621,1.534,47.068.426,2.21-.5,2.71,7.454,1.426,9.37-1.962,2.929-48.657,2.461-50.135.355S1689.2,1096.159,1691.816,1096.861Z",
    transform: "translate(-1670.255 -981.897)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_626",
    "data-name": "Group 626",
    transform: "translate(50.611 70.421)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_625",
    "data-name": "Group 625",
    transform: "translate(0.386)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1518",
    "data-name": "Path 1518",
    d: "M1841.693,894.843c-.011-.091-.016-.136-.018-.158a7.036,7.036,0,0,1-1.9-.471,5.65,5.65,0,0,1-1.541-.908h0l0,.006a5.084,5.084,0,0,1-.572.647,6.424,6.424,0,0,1-.977.76c-.18.116-.365.227-.559.327a6.893,6.893,0,0,1-.905.39c.006.053.03.259.109.938.016.136.034.291.054.467l.032.281.123,1.056a4.289,4.289,0,0,0,.435,1.453,4.52,4.52,0,0,0,.233.405,5.044,5.044,0,0,0,.859,1,6.342,6.342,0,0,0,.938.694,6.979,6.979,0,0,0,1.02.512c.124.05.219.083.274.1a7.17,7.17,0,0,0,.874-.671,6.966,6.966,0,0,0,.5-.5c.085-.094.169-.192.252-.3a4.584,4.584,0,0,0,1.067-3.449C1841.8,895.79,1841.725,895.114,1841.693,894.843Z",
    transform: "translate(-1835.22 -893.305)",
    fill: "#ffb27d"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_463",
    "data-name": "Rectangle 463",
    width: 9.181,
    height: 1.684,
    transform: "translate(0 11.374) rotate(-5.561)",
    fill: "#1d498c"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1519",
    "data-name": "Path 1519",
    d: "M1819.081,1171.342h-2.806l.057-.241c1.26-5.329,1.433-18.291,1.434-18.422l.392,0c0,.129-.169,12.758-1.389,18.266h1.992c.258-1.3,2-10.489,1.564-17.938l.392-.023c.476,8.051-1.582,18.1-1.6,18.2Z",
    transform: "translate(-1769.42 -1025.539)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_627",
    "data-name": "Group 627",
    transform: "translate(1.032 57.097)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1520",
    "data-name": "Path 1520",
    d: "M1613.848,962.92s-3.691,20.891.071,28.258c3.888,7.613,39.787,9.27,39.787,9.27l1.287-10.8-24.739-6.277,5.372-16Z",
    transform: "translate(-1611.027 -934.374)",
    fill: "#f7a594"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1521",
    "data-name": "Path 1521",
    d: "M1623.431,834.058a55.094,55.094,0,0,0-10.849,30.952c13.593,9.91,22.55,2.771,22.55,2.771s6.893-18.218,5.365-27.083S1626.517,830.84,1623.431,834.058Z",
    transform: "translate(-1611.303 -832.38)",
    fill: "#614385"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1522",
    "data-name": "Path 1522",
    d: "M1608.476,956.624c1.84,2.24,22.967,6.611,23.4,4.151a6.928,6.928,0,0,1-1.432,6.779c-.538,3.416-23.442-.181-22.9-3.6Q1605.547,960.786,1608.476,956.624Z",
    transform: "translate(-1606.734 -929.455)",
    fill: "#9a82b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1523",
    "data-name": "Path 1523",
    d: "M1721.021,940.676a.193.193,0,0,1-.1-.027.2.2,0,0,1-.069-.269,32.064,32.064,0,0,0,3.509-9.575.2.2,0,0,1,.385.077,32.46,32.46,0,0,1-3.556,9.7A.2.2,0,0,1,1721.021,940.676Z",
    transform: "translate(-1695.876 -909.159)",
    fill: "#231f20"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_543",
    "data-name": "Group 543",
    transform: "translate(2192.088 1056.923)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_951",
    "data-name": "Path 951",
    d: "M3303.193,1239.93c-.528-1.627-.926-2.808-1.126-3.393-.091-.272-.14-.415-.14-.415a5.187,5.187,0,0,0-.426.486c-1.637,2.052-7.26,10.875-3.035,31.3.621,3,1.456,6.263,2.546,9.784,0,0-15.567-2.747-19.962-5.675-.184-.458-2.473-7.235-4.213-8.15s-4.944-1.923-5.677-1.557-2.106,5.494,0,8.149,7.508,5.22,7.508,5.22,17.4,13.919,29.486,13.551C3318.254,1288.925,3307.124,1252.044,3303.193,1239.93Z",
    transform: "translate(-3270.015 -1182.824)",
    fill: "#d9935c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_952",
    "data-name": "Path 952",
    d: "M3494.5,1449.456a21.419,21.419,0,0,1-.859-4.121c-8.79,3.846-18.4,2.2-18.4,2.2a25.455,25.455,0,0,0-.1,8.1c9.888,2.655,20.853-3.159,20.853-3.159A23.719,23.719,0,0,1,3494.5,1449.456Z",
    transform: "translate(-3386.817 -1302.141)",
    fill: "#a8d29f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_953",
    "data-name": "Path 953",
    d: "M3432.768,1292.592c-.4.962-2.119,1.817-4.6,2.432l-.709.167c-5.62,1.224-14.511,1.293-21.064-1.134-7.33-2.716-12.65-41.465-14.91-61.33-.034-.3-.069-.6-.1-.9-.725-6.428-1.108-10.661-1.108-10.661s4.211-6.592,20.513-4.4,17.945,7.692,19.41,17.583S3434.048,1289.477,3432.768,1292.592Z",
    transform: "translate(-3338.59 -1171.534)",
    fill: "#9a82b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_954",
    "data-name": "Path 954",
    d: "M3428.931,1302.6c-5.619,1.225-14.51,1.293-21.063-1.134-7.331-2.716-12.65-41.464-14.91-61.329-.034-.305-.069-.6-.1-.9,1.663-5.758,2.918-9.436,2.918-9.436s20.466-2.471,24.45,3.708C3423.707,1238.91,3427.922,1289.849,3428.931,1302.6Z",
    transform: "translate(-3340.061 -1178.94)",
    fill: "#462c65"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_955",
    "data-name": "Path 955",
    d: "M3406.545,1301.617c-1.206-.762-2.372-3.081-2.8-4.006-3.72-9.244-8.012-27.226-9.431-30.534-.516-1.2-1.506-6.881-2.8-14.2-2.326-13.126-5.636-31.525-8.952-38.816a5.607,5.607,0,0,0-3.033-2.241c-3.963-1.658-10.4-2.467-11.9-2.64-1.6-1.285-3.816-6.8-3.786-15.206l-.718.142-12.074,2.39s.274,3.8.283,7.38c.008,2.983-.172,5.81-.848,6.167-.869.078-1.382.13-1.382.13s-10.068,13.982-10.914,26.985,8.062,18.652-.067,44.638c-8.3,26.54,48.1,9.8,45,2.856-5.606-12.572-8.288-16.127-8.381-20.082-.066-2.779,1.145-5.757,3.517-12.189.21.774.417,1.542.621,2.3,1.343,4.988,2.494,9.441,2.963,11.667,1.439,6.834,17.27,33.1,17.27,33.1h0l0,0s.48.319,1.04,1.919,5.036,10.074,6.956,10.074,2.319-2.878,2.719-4.717S3408.063,1302.576,3406.545,1301.617Z",
    transform: "translate(-3308.363 -1158.788)",
    fill: "#d9935c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_956",
    "data-name": "Path 956",
    d: "M3391.062,1113.627c-2.678-1.639-6.957.319-6.957.319,1.48-2.078,6.877-1.4,6.877-1.4-10.778-2.293-13,4.616-13.179,5.229-7.8-7.037-20.283,7.963-20.283,7.963l17.916,23.748s1.635-3.778,3.793-2.6c3.365,1.838,9.876-5.6,7.8-15.392a25.777,25.777,0,0,0-.8-2.913,5.8,5.8,0,0,0,2.235.554c1.959,0,4.918-5,5.317-6.676S3393.741,1115.266,3391.062,1113.627Z",
    transform: "translate(-3319.906 -1112.083)",
    fill: "#233862"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_957",
    "data-name": "Path 957",
    d: "M3369.309,1196.7s.274,3.8.283,7.379c6.756-.19,10.328-6.354,11.791-9.77Z",
    transform: "translate(-3326.63 -1158.975)",
    fill: "#cb7d45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_958",
    "data-name": "Path 958",
    d: "M3372.537,1158.319s3.541-5.595,4.39-10.378c.607-3.416-1.132-16.075-13.854-14.252a17.3,17.3,0,0,0-7.168,2.71c-2.761,1.866-6.748,5.893-2.291,16.94l1.157,3.732Z",
    transform: "translate(-3316.538 -1124.303)",
    fill: "#233862"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_959",
    "data-name": "Path 959",
    d: "M3356.991,1171.957s15.985.263,16-9.694,2.082-16.63-8.124-17.219-12.194,3.208-13.006,6.531S3352.833,1171.631,3356.991,1171.957Z",
    transform: "translate(-3316.568 -1130.846)",
    fill: "#d9935c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_960",
    "data-name": "Path 960",
    d: "M3367.984,1530.087a157.929,157.929,0,0,1-10.076,28.264l-5.271-.365a149.124,149.124,0,0,0,2.437-28.915c-.1-11.617-1.541-25.347-6.132-38.455-15.773-45.048-13.224-77.834-13.224-77.834l29.662,3.47,1.381.161c.124,13.623.475,32.118.783,46.582.272,13.006.511,22.75.511,22.75C3373.758,1498.026,3371.687,1515.363,3367.984,1530.087Z",
    transform: "translate(-3307.386 -1283.575)",
    fill: "#dc7572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_961",
    "data-name": "Path 961",
    d: "M3393.344,1315.963c-3,8.276-4.539,11.651-4.464,14.779-9.549-14.786-26.8-17.017-26.8-17.017l32.754-3.744A30.9,30.9,0,0,1,3393.344,1315.963Z",
    transform: "translate(-3322.509 -1224.947)",
    fill: "#cb7d45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_962",
    "data-name": "Path 962",
    d: "M3404.2,1519.242c-1.706,18.2-9.215,29.971-9.215,29.971l-2.519,1.832s-2.382-12.824-4.069-28.081c-1.607-14.5-3.81-29.846-6.3-34.53-9.892-18.575-12.869-88.7-12.869-88.7l30.074-1.491c3.024,5.084,4.343,13.424,4.656,22.907.791,23.932-4.835,55.138-5.675,59.651a.016.016,0,0,1,0,.01,1.579,1.579,0,0,0,.2,1.009C3404.455,1493.667,3405.319,1507.218,3404.2,1519.242Z",
    transform: "translate(-3326.58 -1275.285)",
    fill: "#dc7572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_963",
    "data-name": "Path 963",
    d: "M3367.225,1155.754c6.717,1.727,9.63-.073,9.63-.073a17.019,17.019,0,0,0-6.221-11.238c-8.3-6.4-14.014-2.824-14.367-2.3-1.046-.9-2.913-1.56-5.385,1.436-3.706,4.492-.409,12.432-.409,12.432,1.521.177,1.88-5.042,2.677-7.578.586-1.867,2.51-3.77,3.485-4.645.314,1.153,3.531,12.334,11.566,16.048a37.312,37.312,0,0,1-6.419-7.839A11.425,11.425,0,0,0,3367.225,1155.754Z",
    transform: "translate(-3315.117 -1128.39)",
    fill: "#233862"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_964",
    "data-name": "Path 964",
    d: "M3308.641,1765.665a.384.384,0,0,0-.031.034h-1.651a2.862,2.862,0,0,1,.438-.034Z",
    transform: "translate(-3291.071 -1484.829)",
    fill: "#283250"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_965",
    "data-name": "Path 965",
    d: "M3379.591,1314.474a7.117,7.117,0,0,1-.187,2.4c-.64,2.013-2.838,2.931-8.15,2.381-3.247-.338-4.7-5.779-5.34-10.422q-2.927,9.964-8.212,11.153c-5.15,1.146-31.132,4.3-32.832-8.046-1.871-13.584,3.731-37.637,4.038-50.606a64.246,64.246,0,0,1-.942-12.018c.217-9.239,2.928-14.416,5.014-16.5.591-.453,1.181-.736,3.552-1.143,1.211-.206,2.89-.445,5.268-.758a8.9,8.9,0,0,1,.949-.073c-.439.786-6.323,9.7-5.865,11.987.48,2.4,21.35.239,22.789-1.08s3.717-11.422,3.717-11.422,7.389.808,11,3.437l-.038.047a3.024,3.024,0,0,1,.95,1c3.857,7.343,7.708,25.874,10.417,39.092a19.244,19.244,0,0,1-14.081,2.063C3373.969,1291.193,3379.245,1307.538,3379.591,1314.474Z",
    transform: "translate(-3301.069 -1179.52)",
    fill: "#ffb2af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_966",
    "data-name": "Path 966",
    d: "M3346.4,1231.7s-.01.02-.033.055c-.709,1.121-11.8,18.842-12.858,30.366a64.171,64.171,0,0,1-.942-12.018c1.426-4.354,4.887-14.026,8.566-17.644C3341.589,1232,3346.4,1231.7,3346.4,1231.7Z",
    transform: "translate(-3305.665 -1180.301)",
    fill: "#9a82b8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_540",
    "data-name": "Group 540",
    transform: "translate(0 75.947)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_967",
    "data-name": "Path 967",
    d: "M3286.29,1303.126l-4.654-13.976a.466.466,0,0,0-.588-.293l-7.329,2.44a.465.465,0,0,0-.293.588l4.653,13.975a.464.464,0,0,0,.586.294l7.33-2.441A.466.466,0,0,0,3286.29,1303.126Z",
    transform: "translate(-3271.933 -1288.833)",
    fill: "#f1a34f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_968",
    "data-name": "Path 968",
    d: "M3282.662,1304.124l-4.426-13.295a.824.824,0,0,0-1.042-.521l-6.648,2.214a.823.823,0,0,0-.521,1.041l4.427,13.294a.823.823,0,0,0,1.041.521l6.648-2.214A.822.822,0,0,0,3282.662,1304.124Z",
    transform: "translate(-3269.983 -1289.65)",
    fill: "#d86713"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_969",
    "data-name": "Path 969",
    d: "M3429.643,1679.839c-1.707,18.2-9.215,29.972-9.215,29.972l-2.564,2.335s-2.338-13.327-4.024-28.584C3415.616,1683.69,3423.451,1683.976,3429.643,1679.839Z",
    transform: "translate(-3352.026 -1435.881)",
    fill: "#d9935c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_970",
    "data-name": "Path 970",
    d: "M3390.643,1684.435a158.009,158.009,0,0,1-10.076,28.264l-5.272-.365a149.133,149.133,0,0,0,2.438-28.915C3379.519,1684.32,3383.212,1685.235,3390.643,1684.435Z",
    transform: "translate(-3330.043 -1437.923)",
    fill: "#d9935c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_541",
    "data-name": "Group 541",
    transform: "translate(29.872 266.996)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_971",
    "data-name": "Path 971",
    d: "M3363.189,1745.657h-3.365c-1.128-.177-1.96-.5-3.117-.655a3.122,3.122,0,0,0-2.725.655.367.367,0,0,0-.031.033h-14.3c-.36-.513-.015-1.7.323-2.578a2.034,2.034,0,0,1,1.339-1.223c1.515-.439,4.5-.83,7.241-3.308,1.54-1.391,7.436-5.117,7.436-5.117l.031-.007c.13,0,.746.192,3.427,2.457,1.387,1.168,3.75-1.651,3.75-1.651a3.378,3.378,0,0,1,.775,1.051,3.553,3.553,0,0,1,.307,2.195c-.213,1.288.475,3.682,1.025,5.3.333.981.614,1.677.614,1.677S3366.084,1745.295,3363.189,1745.657Z",
    transform: "translate(-3339.502 -1733.457)",
    fill: "#233862"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_972",
    "data-name": "Path 972",
    d: "M3385.87,1735.314a10.669,10.669,0,0,1-3.625,1.828c-1.518.2-4.358-3.677-4.358-3.677l.031-.007c.129,0,.746.192,3.427,2.457,1.387,1.168,3.75-1.651,3.75-1.651A3.367,3.367,0,0,1,3385.87,1735.314Z",
    transform: "translate(-3361.394 -1733.457)",
    fill: "#466aa5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_973",
    "data-name": "Path 973",
    d: "M3363.189,1758.071h-3.365c-1.128-.177-1.96-.5-3.117-.655a3.122,3.122,0,0,0-2.725.655.4.4,0,0,0-.031.033h-14.3c-.36-.513-.015-1.7.323-2.578.434-.386.557,1.676.8,2.005s11.663.12,12.323-.359a6.9,6.9,0,0,1,5.4-.659c2.4.573,5.939-.9,6.815-1.288.333.981.614,1.676.614,1.676S3366.084,1757.708,3363.189,1758.071Z",
    transform: "translate(-3339.502 -1745.871)",
    fill: "#466aa5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_542",
    "data-name": "Group 542",
    transform: "translate(47.831 266.996)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_974",
    "data-name": "Path 974",
    d: "M3404.985,1745.657h-3.365c-1.127-.177-1.96-.5-3.116-.655a3.124,3.124,0,0,0-2.725.655c-.021.021-.031.033-.031.033h-14.3c-.36-.513-.015-1.7.324-2.578a2.032,2.032,0,0,1,1.338-1.223c1.516-.439,4.5-.83,7.242-3.308,1.541-1.391,7.437-5.117,7.437-5.117l.031-.007c.13,0,.746.192,3.428,2.457,1.387,1.168,3.749-1.651,3.749-1.651a3.383,3.383,0,0,1,.776,1.051,3.556,3.556,0,0,1,.307,2.195c-.214,1.288.474,3.682,1.023,5.3.334.981.615,1.677.615,1.677S3407.88,1745.295,3404.985,1745.657Z",
    transform: "translate(-3381.299 -1733.457)",
    fill: "#233862"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_975",
    "data-name": "Path 975",
    d: "M3427.667,1735.314a10.678,10.678,0,0,1-3.625,1.828c-1.519.2-4.358-3.677-4.358-3.677l.03-.007c.131,0,.746.192,3.428,2.457,1.387,1.168,3.75-1.651,3.75-1.651A3.373,3.373,0,0,1,3427.667,1735.314Z",
    transform: "translate(-3403.19 -1733.457)",
    fill: "#466aa5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_976",
    "data-name": "Path 976",
    d: "M3404.985,1758.071h-3.365c-1.127-.177-1.96-.5-3.116-.655a3.124,3.124,0,0,0-2.725.655l-.031.033h-14.3c-.36-.513-.015-1.7.324-2.578.433-.386.557,1.676.8,2.005s11.662.12,12.322-.359a6.9,6.9,0,0,1,5.4-.659c2.4.573,5.939-.9,6.814-1.288.334.981.615,1.676.615,1.676S3407.88,1757.708,3404.985,1758.071Z",
    transform: "translate(-3381.299 -1745.871)",
    fill: "#466aa5"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_977",
    "data-name": "Path 977",
    d: "M3425.679,1356.049c-3.568-1.192-8.147-4.362-13.647-11.469-14.559-18.817-1.236-40.93.55-41.343s5.148,14.306,5.148,14.306C3420.057,1332.768,3425.334,1349.113,3425.679,1356.049Z",
    transform: "translate(-3347.157 -1221.096)",
    fill: "#dc6a67",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_978",
    "data-name": "Path 978",
    d: "M3412.789,1227.172s-14.652,9.981-15.75,31.133,17.947,25.456,17.947,25.456l-1.236-6.685s-15.429-5.585-11.4-22.434a49.353,49.353,0,0,1,16.115-26.005Z",
    transform: "translate(-3342.419 -1177.72)",
    fill: "#9a82b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_979",
    "data-name": "Path 979",
    d: "M3271.69,1299.873s1.374-2.838,3.892-1.694,1.419,5.448-.046,6.959a14.742,14.742,0,0,0-1.877,2.2Z",
    transform: "translate(-3270.957 -1218.061)",
    fill: "#d9935c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_544",
    "data-name": "Group 544",
    transform: "translate(2140.782 1042.821)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_980",
    "data-name": "Path 980",
    d: "M2838.451,1245.334c-.16-4.086-5.678-6.1-5.678-6.1-2.688-1.627-2.531-20.686-3.517-31.911a55.491,55.491,0,0,0-.829-6.381c-1.576-7.094-2.054-32.19-6.784-36.131s-15.713-5.6-15.713-5.6,3.536,18.935,7.4,38.714c4.192,21.5,14.4,42.047,15.283,42.852l.009.007a17.536,17.536,0,0,0,4.634,5.511c1.592,1.061.743,3.184,2.653,3.4C2838.438,1249.967,2838.534,1247.466,2838.451,1245.334Z",
    transform: "translate(-2765.106 -1122.693)",
    fill: "#d9935c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_981",
    "data-name": "Path 981",
    d: "M2774.372,1134.262l-.008,1.553s.423,4.857-5.558,5.566-10.511-1.894-10.349-5.642a43.994,43.994,0,0,0,1.17-7.3,16.885,16.885,0,0,0-.212-2.909L2771,1125.3l3.414.557Z",
    transform: "translate(-2733.392 -1100.049)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_982",
    "data-name": "Path 982",
    d: "M2776.352,1125.862l-.044,8.4a9.8,9.8,0,0,1-4.177.922c-5.326,0-8.769-3.905-10.568-6.74a16.887,16.887,0,0,0-.212-2.909l11.589-.231Z",
    transform: "translate(-2735.327 -1100.049)",
    fill: "#eca26f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_983",
    "data-name": "Path 983",
    d: "M2771.431,1089.988s-14.843,3-16.567-6.273-4.8-15.13,4.6-17.436,11.909.888,13.237,3.843S2775.248,1088.97,2771.431,1089.988Z",
    transform: "translate(-2729.73 -1060.093)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_984",
    "data-name": "Path 984",
    d: "M2805.929,1159.2s2.039,10.913,4.708,24.823c.846,4.414,1.757,9.127,2.687,13.892,3.78,7.409,7.024,12.447,8.026,11.5,2.044-1.93,5.634-2.168,7.906-2.1a55.491,55.491,0,0,0-.829-6.381c-.125-.561-.242-1.233-.356-2-1.322-8.926-2.072-30.5-6.428-34.132C2816.914,1160.868,2805.929,1159.2,2805.929,1159.2Z",
    transform: "translate(-2765.106 -1122.693)",
    fill: "#c7abeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_985",
    "data-name": "Path 985",
    d: "M2843.1,1234.322c2.045-1.93,5.634-2.168,7.906-2.1a55.563,55.563,0,0,0-.829-6.381c-.125-.561-.242-1.233-.356-2l-11.334-27.359S2842.095,1235.271,2843.1,1234.322Z",
    transform: "translate(-2786.852 -1147.598)",
    fill: "#9a82b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_986",
    "data-name": "Path 986",
    d: "M2748.947,1744.92a28.443,28.443,0,0,0-1.9-7.006c-1.284-2.569-9.459-.934-9.459-.934s-1.634,1.4-1.985,7.941Z",
    transform: "translate(-2718.13 -1508.298)",
    fill: "#233862"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_987",
    "data-name": "Path 987",
    d: "M2857.167,1734.92c-1.921-1.172-.807-9.68-.807-9.68s8.949-7.16,10.18-1.678,8.5,7.943,12.642,8.614c2.857.464,3.044,1.807,3.318,2.744Z",
    transform: "translate(-2798.578 -1498.297)",
    fill: "#233862"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_988",
    "data-name": "Path 988",
    d: "M2777.19,1436.747a41.264,41.264,0,0,1,.657,4.834c.832,16.229,13.661,53.336,15.956,54.2,3.551,1.34,9.142-1.508,12.067-2.44a2.51,2.51,0,0,0,1.761-2.85c-6.353-29.207-8.688-71.263-9.538-96.163a112.94,112.94,0,0,0-2.583-21.2s-31.289-8.349-31.475,2.212C2763.87,1384.682,2774.4,1421.331,2777.19,1436.747Z",
    transform: "translate(-2737.12 -1263.497)",
    fill: "#614385"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_989",
    "data-name": "Path 989",
    d: "M2777.19,1436.747l20.9-42.418a112.94,112.94,0,0,0-2.583-21.2s-31.289-8.349-31.475,2.212C2763.87,1384.682,2774.4,1421.331,2777.19,1436.747Z",
    transform: "translate(-2737.12 -1263.497)",
    fill: "#462c65"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_990",
    "data-name": "Path 990",
    d: "M2754.012,1378.529l-16.541,119.883s-7.264,1.751-12.913.35c0,0-4.843-63.76-4.439-79.174s-3.476-41.246.885-44.094S2754.012,1378.529,2754.012,1378.529Z",
    transform: "translate(-2706.979 -1266.652)",
    fill: "#614385"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_991",
    "data-name": "Path 991",
    d: "M2717.926,1231.527a2.471,2.471,0,0,0,2.433,2.568l26.066.4,19.146.292c.9.016-1.937-7.157-2-53.926-.014-10.436-16.171-21.666-16.469-21.666l0,0c0,1.5-2.369,4.277-6.017,4.516-4.33.284-9.643-1.871-9.643-4.365a11.632,11.632,0,0,0-1.312,1.694c-2.162,3.149-6.517,10.828-9.3,24.2-2.195,10.557-1.351,24.672-2.93,42.884C2717.789,1229.437,2717.959,1230.605,2717.926,1231.527Z",
    transform: "translate(-2706.279 -1122.686)",
    fill: "#f98b88"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_992",
    "data-name": "Path 992",
    d: "M2718.839,1234.24a53.1,53.1,0,0,0,9.946,2.9,97.969,97.969,0,0,0,19.27,1.936c12.67.081,17.468-4.286,17.468-4.286.9.016-1.937-7.157-2-53.926-.014-10.436-16.171-21.666-16.469-21.666l0,0s.415,13.9-3.789,17.984c0,0-5.9-4.554-13.546-17.516-2.161,3.15-6.153,12.205-8.933,25.574a72.281,72.281,0,0,0-1.185,8.876c-.737,9.224-.572,20.487-1.746,34.008-.115,1.316.054,2.484.021,3.405C2717.824,1232.916,2717.45,1234.219,2718.839,1234.24Z",
    transform: "translate(-2706.231 -1122.686)",
    fill: "#c7abeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_993",
    "data-name": "Path 993",
    d: "M2718.839,1286.876a53.125,53.125,0,0,0,9.946,2.9c2.039-3.109,4.608-8.721,4.964-17.565.6-14.955-13.6-34.215-13.6-34.215l-.542,8.759c-.737,9.224-.572,20.487-1.746,34.008-.115,1.315.054,2.483.021,3.4C2717.824,1285.552,2717.45,1286.855,2718.839,1286.876Z",
    transform: "translate(-2706.231 -1175.322)",
    fill: "#9a82b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_994",
    "data-name": "Path 994",
    d: "M2755.047,1227.3l-18.656-10.771a3.21,3.21,0,0,0-4.385,1.174l-15.969,27.659a3.21,3.21,0,0,0,1.176,4.385l18.656,10.771a3.211,3.211,0,0,0,4.385-1.175l15.968-27.658A3.21,3.21,0,0,0,2755.047,1227.3Z",
    transform: "translate(-2704.772 -1160.701)",
    fill: "#b64c41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_995",
    "data-name": "Path 995",
    d: "M2730.08,1204.466c-.425-1.168-4.591-2.686-6.036-2.686-1.429,0-5.1,3.42-5.183,3.5-1.051-.048-11.367-.543-19.035-1.666a48.317,48.317,0,0,1-5.276-1.016c-1.759-.471,6.969-22.593,11.374-35.6,1.051-3.1,1.855-5.69,2.212-7.338,0,0-.769.125-1.978.363-3.428.676-10.394,2.266-13.359,4.509-4.012,3.033-14.024,37.23-7.883,50.448a74.775,74.775,0,0,0,13.437-.387,129.155,129.155,0,0,0,23.12-4.64,3.433,3.433,0,0,0,.616.006,53.554,53.554,0,0,0,7.4-1.752C2730.675,1207.735,2730.5,1205.633,2730.08,1204.466Z",
    transform: "translate(-2682.97 -1122.996)",
    fill: "#d9935c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_996",
    "data-name": "Path 996",
    d: "M2684.915,1215.614a74.766,74.766,0,0,0,13.437-.387,16.051,16.051,0,0,1,1.473-10.976,48.341,48.341,0,0,1-5.276-1.016c-1.759-.471,6.969-22.592,11.374-35.6.352-4.206.537-7.021.537-7.021l-.3.045c-3.428.676-10.394,2.267-13.359,4.509C2688.786,1168.2,2678.773,1202.4,2684.915,1215.614Z",
    transform: "translate(-2682.97 -1123.634)",
    fill: "#c7abeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_997",
    "data-name": "Path 997",
    d: "M2760.217,1174.369s-11.795-5.2-11.97-5.606a9.344,9.344,0,0,1,1.4-4.5s-5.664.526-6.014-.175-.467-6.539-.467-6.539a9.034,9.034,0,0,1,5.138-2.57s2.556,6.339,3.5,8.233C2754.32,1168.238,2760.217,1174.369,2760.217,1174.369Z",
    transform: "translate(-2723.181 -1119.874)",
    fill: "#9a82b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_998",
    "data-name": "Path 998",
    d: "M2797.322,1164.14a39.336,39.336,0,0,1-2.8,10.276s6.16-4.292,6.686-5.693-1.489-4.116-1.489-4.116,3.678-.088,3.766-1.314a39.581,39.581,0,0,0-1.139-6.043s-3.008-2.28-3.884-2.193Z",
    transform: "translate(-2757.484 -1119.922)",
    fill: "#9a82b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_999",
    "data-name": "Path 999",
    d: "M2767.346,1052.376a31.115,31.115,0,0,1-9.021-2.441c-3.963-1.723-8.962.174-10.584,1.029a2.423,2.423,0,0,1,.4-.976,2.181,2.181,0,0,0-.836,1.239c-.075.055-.108.094-.089.106a2.793,2.793,0,0,0-1.356.088s.371-.053.5.186a.22.22,0,0,0,.059.065c-6.181,2.986-6.751,12.755-4.762,15.016,2.393,2.719,5.262,8.843,5.262,8.843a5.25,5.25,0,0,0,.612-3.84c-.435-2.393,1.631-2.393,4.242-3.481s.435-4.133,2.719-5.983,10.66-.761,10.551-2.175C2768.151,1058.92,2767.346,1052.695,2767.346,1052.376Z",
    transform: "translate(-2721.488 -1049.236)",
    fill: "#233862"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1000",
    "data-name": "Path 1000",
    d: "M2774.167,1277.443a1.556,1.556,0,1,0,1.557,1.557A1.557,1.557,0,0,0,2774.167,1277.443Z",
    transform: "translate(-2742.849 -1201.676)",
    fill: "#ed6058"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_548",
    "data-name": "Group 548",
    transform: "translate(2087.423 1047.194)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1015",
    "data-name": "Path 1015",
    d: "M3058.775,1368.71s-2.449,2.795-1.018,4.535,3.979,3.239,6.386,1.573,3.053-7.866,1.666-7.866S3058.775,1368.71,3058.775,1368.71Z",
    transform: "translate(-3044.661 -1247.875)",
    fill: "#cb8757"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1016",
    "data-name": "Path 1016",
    d: "M3064.054,1310.266s-7.033,22.95-5.553,26.282,6.272,2.722,8.966-1.23S3064.054,1310.266,3064.054,1310.266Z",
    transform: "translate(-3045.221 -1215.807)",
    fill: "#f98b88"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1017",
    "data-name": "Path 1017",
    d: "M3082.147,1192.322s-10.844,1.963-14.865,5.984-13.51,15.883-7.54,55.436c0,0,.479,11.92,13.883,13.069S3082.147,1192.322,3082.147,1192.322Z",
    transform: "translate(-3044.952 -1149.082)",
    fill: "#dc7572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1018",
    "data-name": "Path 1018",
    d: "M3098.836,1176.239a27.66,27.66,0,0,0,.031-5.063v0c-.072-.849-.157-1.352-.157-1.352l.157-.05,13.024-3.967.322-.1c.192,4.239.439,7.379.7,9.711a35.186,35.186,0,0,0,.875,5.214h-15.836A21.4,21.4,0,0,0,3098.836,1176.239Z",
    transform: "translate(-3067.655 -1134.024)",
    fill: "#d9935c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1019",
    "data-name": "Path 1019",
    d: "M3088.333,1107.831s1.5-21.331,29.2-13.254c6.284,1.833,5.467,20.809-9.753,28.034Z",
    transform: "translate(-3062.213 -1092.75)",
    fill: "#462c65"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1020",
    "data-name": "Path 1020",
    d: "M3116.621,1383.482c-1.864,12.979-14.374,46.714-14.01,58.374.288,9.188.137,30.415-1.076,44.516a86.719,86.719,0,0,1-1.229,9.522c-1.076,5.2-2.456,11.189-3.2,14.965-1.652,8.476-.788,13.418-2.137,17.967-1.486,4.973-18.543,4.063-13.4,1.046a15.088,15.088,0,0,0,5.822-6.323c4.791-10.734-1.926-57.024-3.927-74.87-.258-2.229-.439-4-.515-5.216-.667-11.023-8.234-84.457-8.234-84.457C3093.088,1348.787,3118.471,1370.5,3116.621,1383.482Z",
    transform: "translate(-3054.507 -1241.881)",
    fill: "#d9935c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1021",
    "data-name": "Path 1021",
    d: "M3116.374,1383.449c-1.865,12.979-14.373,46.714-14.01,58.374.288,9.188.137,30.415-1.076,44.516l-18.073-37.693c-.258-2.229-.439-4-.515-5.216-.667-11.023-8.424-84.484-8.424-84.484C3092.653,1348.726,3118.225,1370.47,3116.374,1383.449Z",
    transform: "translate(-3054.26 -1241.847)",
    fill: "#cb8757"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1022",
    "data-name": "Path 1022",
    d: "M3079.415,1360.947s15.782,72.547,17.576,83.439,16.165,62.179,13.032,75.03c-1.847,7.581-5.069,9.824-5.069,9.824-.757,1.39,11.726,4.15,12.733-1.169,1.28-6.754,1.549-16.234,3.424-32.306,3.228-27.672-3.175-43.419-4.728-54.984s5.212-48.326,1.458-60.888C3111.271,1357.908,3096.639,1348.894,3079.415,1360.947Z",
    transform: "translate(-3057.167 -1241.435)",
    fill: "#d9935c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1023",
    "data-name": "Path 1023",
    d: "M3116,1427.974s-4.109.637-10.159,1.062l-3.29-13.191-1.153,13.434c-9.719.394-22.409-.091-31.764-3.957l2.017-66.425s13.549,3.574,29.849-2.688C3101.5,1356.208,3122.695,1372.758,3116,1427.974Z",
    transform: "translate(-3051.633 -1241.797)",
    fill: "#dc7572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1024",
    "data-name": "Path 1024",
    d: "M3153.662,1719.89a111.38,111.38,0,0,0-.929,13.866H3151.4l-.122-10.1c-.1.121-.187.226-.269.322-1.194,1.333-2.766,7.821-3.93,9.779h-14.8a1.382,1.382,0,0,1,.2-1.229v0a6.887,6.887,0,0,1,2.358-1.885,26.912,26.912,0,0,0,9.45-.451c1.976-.5,5.32-18.052,5.32-18.052s4.659,2.835,5.176,4.13C3155.03,1716.889,3154.461,1718.365,3153.662,1719.89Z",
    transform: "translate(-3087.031 -1443.158)",
    fill: "#aa413e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1025",
    "data-name": "Path 1025",
    d: "M3107.246,1720.711a113.635,113.635,0,0,0-.778,11.811v0c-.008.517-.017.934-.022,1.229h-1.337l-.118-9.723c-1.19,1.438-2.74,7.791-3.886,9.723h-14.8c-.565-1.6,2.562-3.118,2.562-3.118a26.914,26.914,0,0,0,9.45-.451c1.976-.5,5.32-18.052,5.32-18.052s4.659,2.835,5.177,4.13C3109.1,1717,3108.262,1718.921,3107.246,1720.711Z",
    transform: "translate(-3061.026 -1443.158)",
    fill: "#aa413e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1026",
    "data-name": "Path 1026",
    d: "M3098.7,1265.78s-12.446,8.59-31.24,2.306c0,0-6.423-21.969-4.4-43.122,1.359-14.192,9.41-25.366,15.394-29.761.942.837,2.6,2.279,14.873-.7,0,0,5.629,2.361,6.633,4.536C3102.093,1203.689,3094.919,1256.552,3098.7,1265.78Z",
    transform: "translate(-3047.69 -1150.317)",
    fill: "#e7f0fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1027",
    "data-name": "Path 1027",
    d: "M3118.749,1272.724c-5.549,1.137-9.824-2.776-16.389-4.656a22.775,22.775,0,0,1-5.565-2.289c-5.867-3.609-8.718-30.324-7.7-40.437,1-10.1,19.069-30.836,19.069-30.836,4.169,3.093,4.948,10.291,7.45,19.737C3121.629,1236.97,3118.749,1272.724,3118.749,1272.724Z",
    transform: "translate(-3062.528 -1150.317)",
    fill: "#dc7572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1028",
    "data-name": "Path 1028",
    d: "M3128.688,1298.436c-5.549,1.137-11.66-.926-16.39-4.656a33.248,33.248,0,0,1-5.367-12.721c-2.987-14.737,8.793-30.734,18.619-41.1C3131.569,1262.682,3128.688,1298.436,3128.688,1298.436Z",
    transform: "translate(-3072.467 -1176.028)",
    fill: "#f98b88"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1029",
    "data-name": "Path 1029",
    d: "M3112.878,1165.93c-1.485,2.488-6.172,9.364-13.055,10.436a27.8,27.8,0,0,0,.031-5.064v0c-.072-.849-.158-1.352-.158-1.352l.158-.051Z",
    transform: "translate(-3068.641 -1134.151)",
    fill: "#cb7d45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1030",
    "data-name": "Path 1030",
    d: "M3087.923,1142.524s16.167,3.247,18.033-6.852,5.211-16.481-5.032-18.981-12.966.981-14.409,4.2S3083.766,1141.419,3087.923,1142.524Z",
    transform: "translate(-3060.395 -1105.812)",
    fill: "#d9935c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1031",
    "data-name": "Path 1031",
    d: "M3111.09,1114.089c-5.408-6.788-12.186-5.891-15.735-4.759a23.04,23.04,0,0,0-3.081-.231c-10.554-.245-7.637,11.944-7.637,11.944.381-7.69,7.042-8.508,7.042-8.508l.23-.068c-.589,2.142-.382,5.575,4.788,8.822,8.339,5.236,7.7,15.708,5.483,18.653C3102.18,1139.941,3118.78,1123.742,3111.09,1114.089Z",
    transform: "translate(-3059.912 -1101.687)",
    fill: "#462c65"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1032",
    "data-name": "Path 1032",
    d: "M3061.693,1390.714c-1.314-5.566-2.8-8.467-4.545-8.87a1.772,1.772,0,0,0-1.456.325c-1.352.966-2.5,3.931-3.5,9.064-.719,3.687-1.084,7.164-1.087,7.2l1.1.114c0-.034.363-3.461,1.073-7.1,1.223-6.259,2.439-7.933,3.055-8.373a.649.649,0,0,1,.562-.146c2.353.543,4.394,9.989,5.126,15.816l1.1-.138C3063.122,1398.564,3062.627,1394.665,3061.693,1390.714Z",
    transform: "translate(-3041.151 -1256.276)",
    fill: "#233862"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_547",
    "data-name": "Group 547",
    transform: "translate(0 140.546)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1033",
    "data-name": "Path 1033",
    d: "M3067.224,1438.346l-2.417-16.033a6.959,6.959,0,0,0-6.881-5.922H3040.8a2.8,2.8,0,0,0-2.8,2.8v19.573a2.8,2.8,0,0,0,2.8,2.8h23.654A2.8,2.8,0,0,0,3067.224,1438.346Z",
    transform: "translate(-3033.739 -1416.391)",
    fill: "#462c65"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1034",
    "data-name": "Path 1034",
    d: "M3050,1416.391h-15.075a3.007,3.007,0,0,0-2.951,2.431l-3.733,19.16a3.006,3.006,0,0,0,2.95,3.581h16.132a3.006,3.006,0,0,0,2.977-2.59l2.677-19.16A3.006,3.006,0,0,0,3050,1416.391Z",
    transform: "translate(-3028.185 -1416.391)",
    fill: "#614385"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1035",
    "data-name": "Path 1035",
    d: "M3068.979,1377.9s-6.991,1.831-7.4,3.277,1.985,5.555,5.94,4.6,7.112-5.67,7.112-5.67Z",
    transform: "translate(-3047.051 -1254.071)",
    fill: "#da935b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1036",
    "data-name": "Path 1036",
    d: "M3100.035,1194.505a21.2,21.2,0,0,1,15.23,11.572c4.928,10.234-4.241,46.784-5.568,49.249s-16.721,22.17-29.8,23.876c0,0-5.557-1.961-5.368-5.182,0,0,21.435-21.214,22.951-24.246s-.6-36.3-.411-40.664S3100.035,1194.505,3100.035,1194.505Z",
    transform: "translate(-3054.401 -1150.317)",
    fill: "#dc7572"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup697);
export default __webpack_public_path__ + "static/media/Group 697.07c5d43f1b8e84378d91bf764a5bb96f.svg";
export { ForwardRef as ReactComponent };